<nav role="navigation" [ngClass]="{'sideNav':true,'hide-menu': router.url == '/telemetry'}">
  <div id="menuToggle">
    <input type="checkbox" aria-label="sideNavBarItem" class="chkHamburger" [checked]="sideNavBar" />

    <span></span>
    <span></span>
    <span></span>

    <ul id="menu">
      <li class="navTabRow hide-in-large" ngbDropdown>
        <a id="user-dropdown" class="nav-link " title="{{loggedInUser || user.email || 'IDMS user'}}" ngbDropdownToggle>
          <img width="14px" height="16px" src="assets/ic-user.svg" alt=""> &nbsp;&nbsp;{{loggedInUser || user.email || 'IDMS user'}}
        </a>
        <div ngbDropdownMenu aria-labelledby="user-dropdown">
          <a class="dropdown-item color-green set-font" href="{{urls.profileUpdate+'&lang='+language}}" translate>{{labels.profileUpdate | translate}}</a>
          <a class="dropdown-item color-green set-font" href="{{urls.pwdUpdate+'&lang='+language}}" translate>{{labels.changePassword | translate}}</a>
          <a class="dropdown-item color-green set-font" href="{{urls.emailUpdate+'&lang='+language}}" translate>{{labels.changeEmail | translate}}</a>
        </div>
      </li>
      <li class="navTabRow hide-in-large" ngbDropdown>
        <a id="language-dropdown" class="nav-link border-shape set-font" ngbDropdownToggle>
          <img width="16px" height="16px" src="assets/ic-countrySelection.svg" alt="">&nbsp;&nbsp; {{currentLanguage}}
        </a>
        <div ngbDropdownMenu aria-labelledby="language-dropdown">
          <button class="dropdown-item set-font " *ngFor="let language of languages" (click)="setLanguage(language)">
            {{language.name}}
          </button>
        </div>
      </li>
      <li *ngIf="roleCd==roles.master" class="navTabRow">
        <a class="nav-link" [ngStyle]="{'border-bottom':router.url == '/broadcastMessages'  ? '4px solid white':''}" (click)="clearAllMenu($event)" routerLink='/broadcastMessages'>
          {{labels.menuBroadcastMessage | translate}}
        </a>
      </li>
      <li *ngFor="let item of navLinks" class="navTabRow">

        <a href='{{item.link}}' rel="noopener noreferrer" target="_blank">
          {{item.name | translate}}
        </a>
      </li>
      <li *ngIf="roleCd===roles.posowner" class="navTabRow">
        <a class="nav-link" (click)="openRexOTTpopup($event, rexOTTModal)">
          {{labels.rexOTT | translate}}
        </a>
      </li>
      <li class="navTabRow  hide-in-large">
        <a (click)="logout()">
          {{labels.logout | translate}}
        </a>
      </li>

      <div class="col-md-12 versionSocialLinks">
        <p class="versionBlock">{{labels.version| translate}}: {{versionName| translate}} </p>
        <div class="col-md-4 socialnav" *ngFor="let item of socialLinks">
          <a href='{{item.link}}' rel="noopener noreferrer" target="_blank">
            <img alt="" width="40px" height="40px" src='{{item.icon}}' />
          </a>
        </div>
      </div>
      <div class="col hide-in-large logo">
        <img alt="" class="se-logo se-logo-img bottom-logo " width="215px" height="101px" src='{{seLogo}}' />
      </div>
    </ul>
  </div>
</nav>

<!-- RexOTT Modal -->
  <div class="se-dialog" #rexOTTModal *ngIf="showReXOTT">
    <div class="se-dialog-holder">
      <div class="se-complex-header">
        <h3 class="se-dialiog-title">{{labels.rexOTT | translate}}</h3>
      </div>
      <div class="se-dialog-body">
        <div *ngIf="this.isLoading" class="se-loader"></div>
        <div class="form-group">
          <textarea 
            id="rexOTTComment" 
            class="form-control" 
            rows="5" 
            [(ngModel)]="rexOTTResponse"
            readonly>
          </textarea>
        </div>
      </div>
      <div class="se-dialog-footer">
        <button class="se-button" (click)="closeModal()">{{labels.close | translate}}</button>
        <button class="se-button button-primary" (click)="copyToClipboard()">{{labels.copyClose | translate}}</button>
      </div>
    </div>
  </div>


<!-- </ng-template> -->
